module.exports = __webpack_public_path__ + "static/media/send_direct_invite.872515d4.png";